import styled from "styled-components";
import { colors, types } from "../../../../../libs";

export const RollAdsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 70vh;  
  width: 75vw;
  margin: auto;
  padding: 20px;
  border: 1px solid ${colors.text.forestGreen};
  border-radius: 10px;
  background-color: ${colors.background.black};
  position: relative;
  text-align: center;
`;

export const BackgroundSVG = styled.img`
  width: 700px;
  height: 700px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const TextContainer = styled.div`
  position: absolute;
  top: 62%; 
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Text = styled.h4`
  color: ${colors.text.white};
    ${types.body.smallTitle};
  margin-bottom: 5px;
`;

export const SubText = styled.h4`
  color: ${colors.text.white};
    ${types.body.smallTitle};
`;

export const ButtonContainer = styled.div`
  position: absolute;
  top: 77%; 
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const PlusIcon = styled.img`
  width: 25px; 
  height: 25px;
  margin-left: 15px;
`;
